import React from 'react'
import clsx from 'clsx'
import { Table, TableHead, TableBody, TableContainer, TableRow, Paper, Checkbox, makeStyles, Box, Typography } from '@material-ui/core'
import ArrowIcon from './ArrowIcon'
import StyledTableRow from './StyledTableRow'
import StyledTableCell from './StyledTableCell'
import './styles.css'

const useTableStyles = makeStyles({
  table: {
    minWidth: 500,
    border: 'none',
  },
  tableContainer: {
    width: '100%',
    border: 'none',
    borderRadius: 0,
    boxShadow: 'none'
  },
  tableHeadRow: {
    border: '1px solid #dadada',
    borderBottom: '2px solid #dadada'
  },
  sortDown: {
    color: '#333',
    width: 12,
    height: 14,
    fill: "none",
    marginLeft: 7,
    cursor: "pointer"
  },
  sortUp: {
    transform: 'rotate(-180deg)',
    color: '#333',
    width: 12,
    height: 14,
    fill: "none",
    marginLeft: 7,
    cursor: "pointer"
  }
})

const StyledTable = ({
  rows,
  columns,
  sortHandler,
  showFilter = false, // boolean value,
  className
}) => {
  const classes = useTableStyles()
  const [sortOrder, setSortOrder] = React.useState(true) // true: sort down, false: sort up

  const handleSort = (field) => {
    setSortOrder(!sortOrder)
    sortHandler(field, !sortOrder)
  }

  return (
    <TableContainer component={Paper} className={clsx(classes.tableContainer, className)}>
      <Table className={classes.Table}>
        <TableHead>
          <TableRow className={classes.tableHeadRow}>
            {columns.map((item, index) => (
              <StyledTableCell align="left" key={index} width={item.width} className={clsx("table-header", item.className)}>
                <Box display="flex" alignItems="center">
                  {item.selectable && <Checkbox
                    onChange={item.selectProps.selectAll}
                    checked={item.selectProps.checked}
                    indeterminate={item.selectProps.itemindeterminate}
                    classes={item.selectProps.classes}
                  />}
                  <Typography className={item.className} noWrap>{item.fieldName}</Typography>
                  {item.sortable && <ArrowIcon
                    onClick={() => handleSort(item.field)}
                    viewBox="0 0 8 11"
                    className={clsx("arrow-icon", sortOrder ? classes.sortDown : classes.sortUp)}
                  />}
                </Box>
                {showFilter && <Box style={{ minHeight: 40, display: "flex", alignItems: "center" }}>
                  {item.filterable && item.filterField}
                </Box>}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows && rows.map((row, index) => (
            <StyledTableRow key={index} className="table-row">
              {columns.map((item, index) => (
                <StyledTableCell scope="row" align={item.align || "left"} key={index} className={item.cellClassName}>
                  {row[item.field]}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default StyledTable